<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>page.controles.controles.modals.modifier-resultat.title</h4>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column">
      <span translate>page.controles.controles.modals.modifier-resultat.message</span>
      <span class="mt-3" translate>page.controles.controles.modals.modifier-resultat.confirmation</span>
    </div>
    <!-- Boutons d'action -->
    <div class="actions-bar mt-3">
      <button type="button" class="btn btn-light" (click)="onClose()" translate>label.non</button>
      <button type="submit" class="btn btn-primary ms-2" (click)="onTerminer()" translate>label.oui</button>
    </div>
  </div>
</div>
